export const constants = { 
    regexPatterns : {
        alphaNumeric: /^[a-zA-Z0-9]+$/,
        numberOnly: /^\d+$/,
    }
}